import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoujjaincab() {



const cardData = {
  keyword: " Mumbai to Ujjain Cab",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Ujjain cab services for travelers planning a spiritual and cultural journey to one of India’s most revered cities. Ujjain, located in Madhya Pradesh, is famous for its Mahakaleshwar Jyotirlinga, ancient temples, and vibrant religious festivals. Whether you are planning a pilgrimage, family trip, or cultural tour, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. The road distance from Mumbai to Ujjain is approximately 590–610 km, and the route offers scenic highway views and convenient stops for refreshments. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, professional chauffeurs skilled in long-distance driving, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Ujjain cab booking.",

topPlaces: [
  {
    title: "Mahakaleshwar Jyotirlinga",
    description:
      "Mahakaleshwar Jyotirlinga is the primary spiritual attraction in Ujjain and one of the twelve Jyotirlingas dedicated to Lord Shiva. The temple is known for its Bhasma Aarti ritual, performed early in the morning, which attracts thousands of devotees. The complex features traditional North Indian architecture with intricately carved pillars, halls, and sanctum sanctorum. Visiting the temple offers devotees an immersive spiritual experience, and traveling by cab from Mumbai ensures a comfortable journey with enough time to perform darshan and participate in temple rituals."
  },
  {
    title: "Kal Bhairav Temple",
    description:
      "Kal Bhairav Temple is dedicated to Lord Kal Bhairav, a fierce manifestation of Lord Shiva, and is one of the most important temples in Ujjain. Devotees come to offer prayers and seek blessings, especially during religious festivals. The temple is famous for its unique practice where devotees offer liquor as a ritual offering. Visitors can admire the temple’s architecture and participate in the local customs. A cab journey from Mumbai allows travelers to conveniently include this spiritual site in their Ujjain itinerary."
  },
  {
    title: "Harsiddhi Temple",
    description:
      "Harsiddhi Temple is an ancient temple dedicated to Goddess Harsiddhi and is known for its historic architecture and vibrant spiritual atmosphere. The temple complex features beautiful stone carvings and is located near the banks of the Shipra River. Devotees and tourists visit to offer prayers, participate in festivals, and experience the calm temple environment. Traveling by cab ensures convenient access to Harsiddhi Temple along with other significant religious sites in Ujjain."
  },
  {
    title: "Ram Ghat",
    description:
      "Ram Ghat is a prominent ghat on the banks of the Shipra River, famous for religious rituals, evening aarti ceremonies, and holy dips. The ghat is a central place for pilgrims visiting Ujjain and is surrounded by smaller temples and shops. Travelers often enjoy the serene atmosphere, watch devotees performing rituals, and capture the spiritual essence of the city. A cab ride from Mumbai allows tourists to reach Ram Ghat comfortably and enjoy the riverside spiritual experience."
  },
  {
    title: "Kaliadeh Palace",
    description:
      "Kaliadeh Palace is a historic palace located on the banks of the Shipra River, showcasing Indo-Islamic architecture and marble craftsmanship. The palace, built by Mughal rulers, has intricate arches, beautiful courtyards, and scenic river views. Visitors can explore the palace grounds and enjoy the blend of history, architecture, and natural beauty. Traveling by cab from Mumbai ensures convenient access to this picturesque landmark."
  },
  {
    title: "Bade Ganesh Temple",
    description:
      "Bade Ganesh Temple is one of the oldest and largest temples dedicated to Lord Ganesha in Ujjain. The temple features impressive idols, traditional carvings, and a vibrant spiritual atmosphere. Devotees visit to perform prayers and rituals, especially on Ganesh Chaturthi. A cab service from Mumbai allows tourists to include this temple in their Ujjain sightseeing tour without worrying about local transport."
  },
  {
    title: "Chintaman Ganesh Temple",
    description:
      "Chintaman Ganesh Temple is dedicated to Lord Ganesha and is known for its spiritual significance and historic architecture. The temple is located near the Shipra River and attracts devotees seeking blessings for peace and prosperity. Travelers can admire the temple carvings and participate in traditional rituals. A cab journey from Mumbai provides convenient access to this sacred site."
  },
  {
    title: "Sandipani Ashram",
    description:
      "Sandipani Ashram is an important historical and spiritual site associated with Lord Krishna’s guru, Sandipani. The ashram is a center of learning and meditation and draws visitors interested in history, spirituality, and ancient Indian education systems. The serene surroundings offer a peaceful retreat from the city. A cab ride from Mumbai allows tourists to comfortably include the ashram in their Ujjain trip."
  },
  {
    title: "Chaudhary Garden",
    description:
      "Chaudhary Garden is a well-maintained public garden in Ujjain offering walking paths, greenery, and leisure spaces for families and tourists. The garden provides a relaxing environment amidst the city and is often visited by locals and travelers for evening walks and photography. Traveling by cab ensures easy access from Mumbai and a hassle-free visit to this urban green space."
  },
  {
    title: "Gadkalika Temple",
    description:
      "Gadkalika Temple is a lesser-known but spiritually significant temple in Ujjain dedicated to Goddess Kalika. The temple is visited by devotees seeking blessings and is known for its peaceful surroundings and traditional architecture. Visitors can combine this temple visit with other prominent Ujjain attractions during their tour. A cab service from Mumbai allows convenient travel to this religious site."
  }
],



services: [
{
name: "Mumbai to Ujjain Cab",
description: "Mumbai to Ujjain cab service offers comfortable long-distance transportation for devotees traveling from Mumbai to the sacred city of Ujjain in Madhya Pradesh. Ujjain is famous for the Mahakaleshwar Jyotirlinga temple, one of the twelve Jyotirlingas of Lord Shiva. Our vehicles are well maintained and suitable for interstate highway travel with comfortable seating and luggage capacity. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles ensure relaxed travel for long-distance journeys. Ideal for pilgrimage tours, family travel, and temple darshan trips. Flexible booking options allow convenient travel planning."
},
{
name: "Mumbai to Ujjain Taxi",
description: "Mumbai to Ujjain taxi service provides reliable transportation for devotees and travelers visiting the holy city of Ujjain. The route connects Maharashtra to Madhya Pradesh through major national highways ensuring smooth interstate travel. Vehicles provide spacious seating and comfortable ride quality suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage travel, temple visits, and family journeys."
},
{
name: "Mumbai to Ujjain Cab Service",
description: "Mumbai to Ujjain cab service provides dependable road transportation for devotees visiting Mahakaleshwar temple and other religious places in Ujjain. Vehicles used for this route are designed for long-distance highway travel and offer comfortable seating for passengers and luggage. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for religious tourism, family travel, and pilgrimage tours."
},
{
name: "Mumbai to Ujjain Taxi Service",
description: "Mumbai to Ujjain taxi service offers convenient transportation for travelers planning visits to the sacred Mahakal temple and nearby religious destinations. Vehicles provide smooth highway performance and spacious seating suitable for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for temple visits, spiritual journeys, and family pilgrimages."
},
{
name: "Cab from Mumbai to Ujjain",
description: "Cab from Mumbai to Ujjain offers comfortable interstate transportation for passengers traveling to the holy city of Ujjain. Vehicles provide smooth ride quality and comfortable seating suitable for highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage tours, tourism travel, and family journeys."
},
{
name: "Taxi from Mumbai to Ujjain",
description: "Taxi from Mumbai to Ujjain provides dependable transportation for travelers visiting the famous Mahakaleshwar temple and other spiritual sites in Ujjain. Vehicles offer comfortable seating and reliable highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Ujjain Cab Booking",
description: "Mumbai to Ujjain cab booking allows devotees to easily reserve vehicles for pilgrimage travel to Mahakaleshwar temple. Online and phone booking options provide instant confirmation and flexible ride scheduling. Vehicles provide comfortable seating and smooth highway travel suitable for long-distance journeys. Professional drivers ensure punctual pickup services across Mumbai."
},
{
name: "Mumbai to Ujjain Taxi Booking Online",
description: "Mumbai to Ujjain taxi booking online provides convenient digital reservations for travelers planning temple visits to Ujjain. Passengers can easily schedule pickups and receive instant booking confirmation. Vehicles provide comfortable seating and smooth ride performance suitable for interstate travel."
},
{
name: "Mumbai to Ujjain Cab Price",
description: "Mumbai to Ujjain cab price options provide transparent fare estimates for devotees planning long-distance temple journeys. Pricing depends on vehicle category, distance, and trip duration. Travelers can choose sedan, SUV, or MPV vehicles depending on comfort needs and group size."
},
{
name: "Mumbai to Ujjain Taxi Fare",
description: "Mumbai to Ujjain taxi fare services offer flexible pricing options depending on vehicle type and travel duration. Passengers can select economical sedans or spacious SUVs based on comfort preferences."
},
{
name: "Mumbai to Ujjain One Way Cab",
description: "Mumbai to Ujjain one way cab service provides economical interstate transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys."
},
{
name: "Mumbai to Ujjain Round Trip Taxi",
description: "Mumbai to Ujjain round trip taxi service offers convenient transportation for devotees planning return journeys after temple darshan. Vehicles are suitable for long-distance highway travel and multi-day trips."
},
{
name: "Mumbai to Ujjain Mahakal Darshan Cab",
description: "Mumbai to Ujjain Mahakal darshan cab service provides dedicated transportation for devotees visiting the Mahakaleshwar Jyotirlinga temple. Vehicles provide comfortable seating and smooth highway performance suitable for pilgrimage travel."
},
{
name: "Jyotirlinga Tour Cab Ujjain",
description: "Jyotirlinga tour cab Ujjain service provides comfortable transportation for devotees planning visits to sacred Jyotirlinga temples including Mahakaleshwar. Vehicles provide spacious seating and reliable long-distance highway travel."
},
{
name: "Religious Tour Cab Ujjain",
description: "Religious tour cab Ujjain provides dedicated transportation for spiritual journeys and temple visits. Vehicles provide comfortable seating and safe long-distance travel for pilgrims visiting Ujjain and nearby religious destinations."
}
],

tableData: [
["Mumbai to Ujjain Cab","Mumbai to Ujjain Taxi"],
["Mumbai to Ujjain Cab Service","Mumbai to Ujjain Taxi Service"],
["Cab from Mumbai to Ujjain","Taxi from Mumbai to Ujjain"],
["Mumbai to Ujjain Cab Booking","Mumbai to Ujjain Taxi Booking Online"],
["Mumbai to Ujjain Cab Price","Mumbai to Ujjain Taxi Fare"],
["Mumbai to Ujjain One Way Cab","Mumbai to Ujjain Round Trip Taxi"],
["Mumbai to Ujjain Mahakal Darshan Cab","Jyotirlinga Tour Cab Ujjain"],
["Religious Tour Cab Ujjain","Ujjain Temple Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance highway travel from Mumbai to Ujjain. They are familiar with interstate routes across Maharashtra and Madhya Pradesh, ensuring a smooth and safe journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Ujjain cab bookings. Customers receive clear information about per-kilometer charges, toll fees, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Ujjain cab service operates 24 hours a day. Whether you want to travel early morning, overnight, or plan a pilgrimage trip, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day pilgrimage packages from Mumbai to Ujjain."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides various vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group pilgrims."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Ujjain journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many devotees traveling from Mumbai to Ujjain for Mahakaleshwar Jyotirlinga darshan. Our punctual drivers, comfortable vehicles, and professional service ensure a peaceful spiritual journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Ujjain?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Ujjain for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Ujjain?", answer: "The distance from Mumbai to Ujjain is approximately 650 km and the journey usually takes around 12 to 14 hours depending on traffic and road conditions." },
  { question: "Can I visit Mahakaleshwar Temple during the trip?", answer: "Yes, many travelers book Mumbai to Ujjain cab services specifically for Mahakaleshwar Jyotirlinga temple darshan." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Ujjain cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during festival seasons and weekends when many devotees travel to Ujjain." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Ujjain." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Joshi",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Ujjain pilgrimage. The driver was very professional and the long journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Kulkarni",
    feedback:
      "Excellent cab service for temple travel. Clean vehicle and smooth driving made our Mahakaleshwar trip very peaceful.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ujjain Cab",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Ujjain for one-way trips, round trips, Mahakal darshan tours, and religious travel. Enjoy safe and comfortable journeys with well-maintained vehicles including Innova, Ertiga, and Sedan. Flexible booking options with transparent pricing.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "900"
  }
};









  return (
    <div>
      


<Helmet>
  <title>Mumbai to Ujjain Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ujjain cab with Omshree Cab for one-way, round trip, Mahakal darshan, and religious tours. Travel safely with Innova, Ertiga, or Sedan. Flexible bookings and transparent pricing." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoujjaincab;